<template>
  <div v-loading="loading" style="height: 500px;width: 100%;" />
</template>

<script>
import { homeHistoryApi } from '@/api/ei/eiApi'
import { debounce } from '@/utils/common'

export default {
  name: 'IncomeBar',

  data() {
    return {
      loading: false,
      stats: {},
      chart: null,
      chartOption: {
        title: {
          text: '近12个月收入统计'
        },
        legend: {
          right: 10
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: [],
          boundaryGap: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '正常缴费',
            type: 'bar',
            barWidth: '61.8%',
            stack: '收入',
            itemStyle: {
              color: '#409eff'
            },
            data: []
          },
          {
            name: '逾期未缴',
            type: 'bar',
            barWidth: '61.8%',
            stack: '收入',
            itemStyle: {
              color: '#e64340'
            },
            data: []
          }
        ]
      }
    }
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      homeHistoryApi().then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.stats = Object.assign({}, res.data.history_income)
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    setChart() {
      this.chartOption.xAxis.data = this.stats.date
      this.chartOption.series[0].data = this.stats.received
      this.chartOption.series[1].data = this.stats.expired
      this.chart.setOption(this.chartOption)
    },

    initChart() {
      this.chart = this.$echarts.init(this.$el, 'teenager')
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
